module.exports = __webpack_public_path__ + "img/r.c54500a9.jpg";